import {useTranslation} from "react-i18next";
import {faBriefcase} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import NestedList, {NestedListT} from "./common/NestedList";

type Stage = {
    role: string,
    period: string,
    tasks: NestedListT
}

const WorkExperience = () =>{
    const {t} = useTranslation();

    const iconWrapper = "mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full " +
        "bg-accentSoft text-accent dark:bg-accent/15"

    const stages: Stage[] = [
        {
            role: t('workExperience.engineer.role'),
            period: t('workExperience.engineer.period'),
            tasks: [
                t('workExperience.engineer.task1'),
                t('workExperience.engineer.task2'),
                t('workExperience.engineer.task3'),
            ]
        },
        {
            role: t('workExperience.junior.role'),
            period: t('workExperience.junior.period'),
            tasks: [
                t('workExperience.junior.task1'),
                t('workExperience.junior.task2'),
                t('workExperience.junior.task3'),
            ]
        },
    ]

    return(
        <div className={"flex flex-col gap-4"}>
            {stages.map((stage, i) =>
                <div key={i} className={"flex items-start gap-3 rounded-xl border border-borderLight " +
                    "dark:border-borderDark bg-surfaceLight dark:bg-surfaceDark p-4 shadow-sm"}>
                    <span className={iconWrapper}>
                        <FontAwesomeIcon icon={faBriefcase}/>
                    </span>
                    <div className={"min-w-0 flex-1"}>
                        <div className={"flex flex-wrap items-baseline justify-between gap-x-3 gap-y-0.5"}>
                            <p className={"font-semibold"}>
                                {stage.role} · {t('workExperience.company')}
                            </p>
                            <p className={"text-sm text-mutedLight dark:text-mutedDark"}>
                                {stage.period}
                            </p>
                        </div>
                        <div className={"mt-1 text-sm sm:text-base"}>
                            <NestedList paraphs={stage.tasks}/>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default WorkExperience
